import {
    createFileRoute,
} from '@tanstack/react-router'

import {
    UserPage,
} from '@/features/users/pages/user-page'

export const Route =
    createFileRoute(
        '/_authenticated/users/',
    )({
        component: UserPage,
    })